/* eslint-disable no-alert */
import axios from "axios";

// const BASE_URL = "http://localhost:8030";
// const BASE_URL = "http://172.16.0.21:8021";
const BASE_URL = "https://csm.depedimuscity.com:8021";

function exportFilteredFeedbacks(data) {
  return axios
    .get(`${BASE_URL}/feedback/filteredReport/exportExcel`, {
      params: {
        startDate: data.startDate,
        endDate: data.endDate,
        ...(data.officeId ? { officeId: data.officeId } : {}), // Only include officeId if it's defined
        ...(data.designationId ? { designationId: data.designationId } : {}),
      },
      responseType: "blob", // Ensure proper file handling
    })
    .then((response) => {
      console.log("API Response received:", response);
      return response;
    })
    .catch((error) => {
      console.error("Error exporting custom report:", error);
      throw error; // Ensure error is caught properly in handle function
    });
}

function exportQuarterlyFeedbacks(data) {
  return axios
    .get(`${BASE_URL}/feedback/QuarterlyReport/exportQuarterlyReport`, {
      params: {
        year: data.year,
        officeId: data.officeId,
        reportType: data.reportType,
        designationId: data.designationId,
      },
      responseType: "arraybuffer",
    })
    .catch((err) => {
      console.error("Download failed:", err);
    });
}

function exportAnnualFeedbacks(data) {
  console.log("Sending request to API with data:", data);

  return axios
    .get(`${BASE_URL}/feedback/YearlyReport/exportYearlyReport`, {
      params: {
        year: data.year || new Date().getFullYear(), // Ensure year is not undefined
        officeId: data.officeId || null, // Ensure officeId is explicitly set
      },
      responseType: "blob",
    })
    .then((response) => {
      console.log("API Response received:", response);
      return response;
    })
    .catch((error) => {
      console.error("Error exporting annual report:", error);
      alert(
        `Error exporting report: ${
          error.response?.data?.message || error.message
        }`
      );
      throw error; // ✅ Rethrow the error so it can be handled in handleYearlyReport
    });
}

function exportMonthlyFeedbacks(data) {
  return axios.get(`${BASE_URL}/feedback/MonthlyReport/exportMonthlyReport`, {
    params: {
      year: data.year,
      month: data.month,
      officeId: data.officeId,
      designationId: data.designationId,
    },
    responseType: "arraybuffer", // Specify response type as arraybuffer
  });
}

function exportYearlyFeedbacks(data) {
  return axios.get(`${BASE_URL}/feedback/YearlyReport/exportYearlyReport`, {
    params: {
      startYear: data.startYear,
      endYear: data.endYear,
      officeId: data.officeId,
      designationId: data.designationId,
    },
    responseType: "arraybuffer", // Specify response type as arraybuffer
  });
}

function addOffice(data) {
  return axios
    .post(`${BASE_URL}/feedback/createOffice`, data)
    .then((res) => res.data);
}

function addService(data) {
  return axios
    .post(`${BASE_URL}/feedback/createService`, data)
    .then((res) => res.data);
}

function updateOffice(id, office) {
  return axios
    .put(`${BASE_URL}/feedback/updateOffice/${id}`, office)
    .then((res) => res.data);
}

function updateService(id, service) {
  return axios
    .put(`${BASE_URL}/feedback/updateService/${id}`, service)
    .then((res) => res.data);
}

function feedbackSubmit(feedback) {
  return axios
    .post(`${BASE_URL}/feedback/submitFeedback`, feedback)
    .then((res) => res);
}

function getAllCategories() {
  return axios.get(`${BASE_URL}/feedback/categories`).then((res) => res.data);
}

function getAllDesignations() {
  return axios.get(`${BASE_URL}/feedback/designations`).then((res) => res.data);
}

function getAllQuestions() {
  return axios.get(`${BASE_URL}/feedback/questions`).then((res) => res.data);
}

function getAllClientTypes() {
  return axios.get(`${BASE_URL}/feedback/clientTypes`).then((res) => res.data);
}

function getAllAgeBrackets() {
  return axios.get(`${BASE_URL}/feedback/ageBrackets`).then((res) => res.data);
}

function getAllServiceReceived(officeId) {
  return axios
    .get(`${BASE_URL}/feedback/services`, officeId)
    .then((res) => res.data);
}

function getAllOffices() {
  return axios.get(`${BASE_URL}/feedback/offices`).then((res) => res.data);
}

function getAllServiceKinds() {
  return axios.get(`${BASE_URL}/feedback/servicekinds`).then((res) => res.data);
}

function getAllFeedbacks() {
  return axios.get(`${BASE_URL}/feedback/feedbacks`).then((res) => res.data);
}

function getAllServices() {
  return axios.get(`${BASE_URL}/feedback/services`).then((res) => res.data);
}

function getAllLevels() {
  return axios.get(`${BASE_URL}/feedback/levels`).then((res) => res.data);
}

function getFilteredServices(categories) {
  return axios
    .get(`${BASE_URL}/feedback/filteredServices`, {
      params: {
        relatedOfficeId: categories.officeId,
        serviceKindId: categories.serviceKindId,
      },
    })
    .then((res) => res.data);
}

function getFilteredUnits(categories) {
  return axios
    .get(`${BASE_URL}/feedback/filteredUnits`, {
      params: {
        levelId: categories.levelId,
        designationId: categories.designationId,
      },
    })
    .then((res) => res.data);
}

function getFilteredFeedbacksByDate(categories) {
  return axios
    .get(`${BASE_URL}/feedback/filteredFeedbackbyDate`, {
      params: {
        startDate: categories.startDate,
        endDate: categories.endDate,
        officeId: categories.officeId,
      },
    })
    .then((res) => res.data);
}

function deleteOffice(id) {
  return axios
    .delete(`${BASE_URL}/feedback/deleteOffice/${id}`)
    .then((res) => res.data);
}

function deleteService(id) {
  return axios
    .delete(`${BASE_URL}/feedback/deleteService/${id}`)
    .then((res) => res.data);
}

export default {
  getAllLevels,
  getAllDesignations,
  exportAnnualFeedbacks,
  exportYearlyFeedbacks,
  exportMonthlyFeedbacks,
  exportQuarterlyFeedbacks,
  exportFilteredFeedbacks,
  addOffice,
  addService,
  deleteOffice,
  deleteService,
  updateOffice,
  updateService,
  getFilteredUnits,
  getFilteredFeedbacksByDate,
  getFilteredServices,
  getAllFeedbacks,
  getAllClientTypes,
  getAllAgeBrackets,
  feedbackSubmit,
  getAllCategories,
  getAllQuestions,
  getAllServiceReceived,
  getAllOffices,
  getAllServiceKinds,
  getAllServices,
};
